<template>
  <div>
    <label
       class="ts-shadow-rounded ts-uppercase ts-p-2 ts-rounded-md"
      >{{ $t('quotation.item') }}</label
    >
    <table class="ts-w-full ts-mt-2">
      <thead>
        <tr>
          <th class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300 ts-row-gap-1/12">
            {{ $t('quotation.barcode') }}
          </th>
          <th class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300 ts-w-1/4">
            {{ $t('quotation.productName') }}
          </th>
          <th class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300 ts-w-32">
            {{ $t('quotation.quantity') }}
          </th>
          <th class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300 ts-w-32">
            {{ $t('quotation.uom') }}
          </th>
          <th class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300 ts-w-32">
            {{ $t('quotation.unitPrice') }}
          </th>
          <th class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300 ts-w-64">
            {{ $t('quotation.grandTotal') }}
          </th>
          <th class="ts-uppercase ts-border ts-px-2 ts-py-1 ts-border-gray-300">
            {{ $t('quotation.remark') }}
          </th>
          <th class="ts-uppercase ts-border ts-px-2 ts-py-1 ​ts-text-center ts-w-1">
            <a href="#" @click.prevent="() => show_modal = true">
              <i class="fa fa-plus"></i>
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(detail, index) in model.item_list">
          <tr
            :key="index"
          >
            <td>
              <input type="text"
                :value="findProduct(detail.product_id).barcode"
                class="ts-py-1 ts-px-2 ts-w-full ts-outline-none"
                readonly
              >
            </td>
            <td>
              <input type="text"
               :value="findProduct(detail.product_id).product_name_en"
                class="ts-py-1 ts-px-2 ts-w-7/12 ts-outline-none"
                readonly
              >
            </td>
            <td>
              <input
                v-model.number="detail.quantity"
                @keypress.enter="onQtyEnter(index)"
                type="number"
                ref="qty"
                class="form-control"
                @input="calculate"
              />
              <div
                class="validate"
                v-if="errors.has('item_list.' + index + '.quantity')"
              >
                {{ errors.first('item_list.' + index + '.quantity') }}
              </div>
            </td>
            <td>
              <a-select
                @keydown.native.enter="onUomEnter(index)"
                v-model="detail.uom_id"
                class="ts-w-full"
                ref="uom"
                :class="{
                  'is-invalid': errors.has('item_list.' + index + '.uom_id'),
                }"
                @change="onUomChange(detail)"
              >
                <a-select-option
                  v-for="(u, index) in getUom(detail.product_id)"
                  :key="index"
                  :value="u.uom_id"
                  >{{ u.uom_name_en }}
                </a-select-option>
              </a-select>
            </td>
            <td>
              <input
                v-model.number="detail.unit_price"
                type="text"
                class="form-control"
                readonly
              />
            </td>
            <td>
              <input
                v-model="detail.amount" 
                type="text" 
                readonly class="form-control">
            </td>
            <td>
              <input 
                v-model.trim="detail.remarks"
                type="text" class="form-control"
                @keypress.enter="onRemarkEnter(index)"
              >
              <div
                class="validate"
                v-if="errors.has('item_list.' + index + '.remarks')"
              >
                {{ errors.first('item_list.' + index + '.remarks') }}
              </div>
            </td>
            <td class="ts-text-center" valign="middle">
              <a
                href="#"
                class="ts-text-red-600 ts-my-auto"
                @click.prevent="removeRow(detail)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
          <tr>
            <td class="ts-pl-12" colspan="9" v-html="getSpecification({ product_id: detail.product_id, uom_id: detail.uom_id })">
            </td>
          </tr>
        </template>
        <template
          v-if="model.item_list.length"
        >
          <tr>
            <td colspan="5" class="text-right">
              <div class="ts-border ts-w-32 ts-py-1 ts-px-2 ts-float-right ts-rounded">
                <b>{{ $t('quotation.vatRate')}}</b>
              </div>
            </td>
            <td class="ts-p-2">
              <div class="ts-border ts-w-full ts-py-1 ts-px-2 ts-float-right ts-rounded">
                <b>{{ model.vat_rate }}</b>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="5" class="text-right">
              <div class="ts-border ts-w-32 ts-py-1 ts-px-2 ts-float-right ts-rounded">
                <b>{{ $t('quotation.vatAmount')}}</b>
              </div>
            </td>
            <td class="ts-p-2">
              <div class="ts-border ts-w-full ts-py-1 ts-px-2 ts-float-right ts-rounded">
                <b>{{ model.vat_amount }}</b>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="5" class="text-right">
              <div class="ts-border ts-w-32 ts-py-1 ts-px-2 ts-float-right ts-rounded">
                <b>{{ $t('quotation.totalExcludevat')}}</b>
              </div>
            </td>
            <td class="ts-p-2">
              <div class="ts-border ts-w-full ts-py-1 ts-px-2 ts-float-right ts-rounded">
                <b>{{ model.total_exclude_vat }}</b>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="5" class="text-right">
              <div class="ts-border ts-w-32 ts-py-1 ts-px-2 ts-float-right ts-rounded">
                <b>{{ $t('quotation.grandTotal')}}</b>
              </div>
            </td>
            <td class="ts-p-2">
              <div class="ts-border ts-w-full ts-py-1 ts-px-2 ts-float-right ts-rounded">
                <b>{{ model.grand_total }}</b>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <a-modal
      v-if="show_modal"
      v-model="show_modal"
      :title="$t('quotation.productList')"
      :footer="null"
      :maskClosable="false"
      :centered="true"
    >
      <ProductList v-model="model"  @calculate="calculate"/>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import ProductList from './product-list.vue'

export default {
  name: 'ItemDetails',
	props: ['value', 'validate'],
  components: {
    ProductList,
  },
  data() {
    return {
			errors: new Errors(),
      show_modal: false,
      model: {},
			newRow: {
				product_id: '',
				uom_id: '',
				quantity: 1,
				unit_price: '',
				remarks: '',
				amount: 0
			}
		}
  },
	computed: {
    ...mapState('wholesale/quotation', ['customers', 'edit_data']),
    ...mapGetters('wholesale/quotation', [
      'getProduct',
      'getUom',
      'isDefaultUom',
      'getSalePrice',
      'getSpecification',
      'findProduct'
    ]),
    isNotEdit() {
      return this.edit_data.length > 0 || _.isEmpty(this.edit_data)
    }
	},
	created() {
    this.model = this.value
  },
	methods: {
    addNewRow() {
      this.model.item_list.push(_.clone(this.newRow))
    },
    removeRow(row) {
      this.model.item_list.splice(
        this.model.item_list.indexOf(row),
        1
      )
    },
		onProductChange(row) {
      row.uom_id = this.isDefaultUom(row.product_id)
      row.unit_price = this.getSalePrice({
        product_id: row.product_id,
        uom_id: row.uom_id,
      })
      this.calculate()
    },
    onUomChange(row) {
      row.unit_price = this.getSalePrice({
        product_id: row.product_id,
        uom_id: row.uom_id,
      })
      this.calculate()
    },
		calculate() {
      if(this.model.item_list.length > 0){
				this.model.item_list.forEach(el => {
					el.amount = _.round(el.quantity * el.unit_price, 2)
				});
				var sum = _.sumBy(this.model.item_list, (o) => o.amount)
				this.model.vat_amount = _.round(sum * (this.model.vat_rate / 100), 2)
				this.model.grand_total = _.round(this.model.vat_amount + sum, 2)
				this.model.total_exclude_vat = _.round(this.model.grand_total - this.model.vat_amount, 2)
			}
    },
    onUomEnter(index){
      this.addNewRow()
      this.$nextTick(() => {
        this.$refs.product[index + 1].focus()
      })
    },
    onRemarkEnter(index){
      this.addNewRow()
      this.$nextTick(() => {
        this.$refs.product[index + 1].focus()
      })
    },
    onQtyEnter(index){
      this.$nextTick(() => {
        this.$refs.uom[index].focus()
      })
    }
	},
	watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  },
}
</script>